import cx from 'classnames';

import { getUserName, type User } from 'src/data/user';
import { usePopoverAnchor } from 'src/lib/hooks';
// @ts-expect-error - no TypeScript definitions yet
import { useCurrentCustomers } from 'src/store/customer/useCurrentCustomers';
import { useSelectedCustomerId } from 'src/store/customer/useSelectedCustomerId';
// @ts-expect-error - no TypeScript definitions yet
import { useCurrentUser } from 'src/store/user';

// @ts-expect-error - no TypeScript definitions yet
import { LogoutPopup } from './LogoutPopup';
// @ts-expect-error - no TypeScript definitions yet
import { ProfileButton } from './ProfileButton';
// @ts-expect-error - no TypeScript definitions yet
import { ProfileMenu } from './ProfileMenu';
import styles from './ReviewerUserProfile.module.scss';
// @ts-expect-error - no TypeScript definitions yet
import { useHandlers } from './useHandlers';

interface ReviewerUserProfileProps {
  className?: string;
}

/** The avatar menu on a reviewer's pages: switching accounts, help and logging out. */
export const ReviewerUserProfile = ({ className }: ReviewerUserProfileProps) => {
  const [menuAnchor, openMenu, closeMenu] = usePopoverAnchor();
  const currentCustomers = useCurrentCustomers();
  const selectedCustomerId = useSelectedCustomerId();
  const user: User | null = useCurrentUser();
  const userName = user ? getUserName(user) : '';
  const {
    dialogLogoutOpened,
    closeLogoutDialog,
    handleCustomerClick,
    handleSettingsClick,
    handleUsageDashboardClick,
    handleEditClick,
    handleLogoutClick,
    handleLogout,
    handleProfileButtonClick,
  } = useHandlers({ openMenu, closeMenu });

  return (
    <div className={cx(styles.root, className)}>
      <ProfileButton
        open={Boolean(menuAnchor)}
        onClick={handleProfileButtonClick}
        name={userName}
        email={user?.email}
      />

      <ProfileMenu
        classes={{ paper: styles.menuPaper }}
        open={Boolean(menuAnchor)}
        anchor={menuAnchor}
        onClose={closeMenu}
        customers={currentCustomers}
        selectedCustomerId={selectedCustomerId}
        onCustomerClick={handleCustomerClick}
        onSettingsClick={handleSettingsClick}
        onUsageDashboardClick={handleUsageDashboardClick}
        onEditClick={handleEditClick}
        onLogoutClick={handleLogoutClick}
        name={userName}
        email={user?.email}
        hideAccountSettings
      />

      <LogoutPopup
        open={dialogLogoutOpened}
        onApprove={handleLogout}
        onReject={closeLogoutDialog}
      />
    </div>
  );
};
